import { graphql } from '../__generated__/gql';

export const GET_CONFIG = graphql(/* GraphQL */ `
  query Config {
    config {
      featureFlags {
        flag
        isEnabled
      }
    }
  }
`);
export const GET_BANNER_MESSAGE = graphql(/* GraphQL */ `
  query BannerMessage {
    bannerMessage
  }
`);

export const GET_SUPPORT_TEAM_EMAILS = graphql(/* GraphQL */ `
  query SupportTeamEmails {
    supportTeamEmails
  }
`);
